/* eslint-disable import/order */
import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import React from 'react'
import { useLocation } from 'react-router-dom'

import Popup from './Popup'
import useContract from './useContract'

import { HBlockAdd } from '../../HYBVant'
import './index.less'

interface IContract {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  isEmployee?: boolean
  employee_id?: string
  staffId?: string
  isAuth?: boolean
}
const Contract: React.FC<IContract> = ({
  isEmployee = false,
  onConfirm,
  staffId = '',
  isAuth = true
}) => {
  const location = useLocation()
  const employee_id = staffId || location.state?.id
  const {
    open,
    modalData,
    onCancel,
    onOpen,
    runDelete,
    runSave,
    saveLoading,
    delLoading,
    runRelieveContracts,
    relieveContractsLoading
  } = useContract({ employee_id, onConfirm })

  return (
    <div className='health_certificate'>
      {!isEmpty(modalData?.dataSource) && (
        <div className='health_certificate-content-wrapper'>
          {modalData?.dataSource?.map?.((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && onOpen({ current: x })}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>{x?.contract_subject_name}</div>
                <div className='health_certificate-content-3'>
                  {x?.contract_type_code === 'UNLIMITED_TERM_EMPLOYMENT_CONTRACT'
                    ? x?.contract_type_name
                    : `${x?.start_date || '-'} 至 ${x?.end_date || '-'}`}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={() => onOpen({ current: {} })} text='添加合同' />}
      {open && (
        <Popup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            isEmployee,
            runSave,
            runDelete,
            runRelieveContracts,
            relieveContractsLoading,
            saveLoading,
            delLoading
          }}
          hrm_employee_id={employee_id}
        />
      )}
    </div>
  )
}

export default Contract
